import { z } from 'zod';

export const searchFilterFormSchema = z.object({
  value: z.string().min(1, 'Enter a value'),
});

export type SearchFilterFormValues = z.infer<typeof searchFilterFormSchema>;
